var _defs, _path, _rect, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightblue02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #a7cbf0;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m42.2,19.34c0,1.03-.83,1.86-1.86,1.86h-10.07c-1.03,0-1.86-.83-1.86-1.86h0c0-1.03.83-1.86,1.86-1.86h10.07c1.03,0,1.86.83,1.86,1.86h0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.53,
    y: 22.36,
    width: 11.38,
    height: 2.98
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m38.85,32.09h-7.72c-2.09,8.06-4.23,12.25-4.23,14.21v30.28c0,1.61.76,2.91,2.37,2.91h11.61c1.61,0,2.37-1.3,2.37-2.91v-30.28c0-2.58-2.73-7.51-4.39-14.21Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m40.91,25.34h-11.38c-.46,6.09-5.79,17.91-5.79,20.35v33.32c0,1.95,1.58,3.53,3.53,3.53h15.47c1.95,0,3.53-1.58,3.53-3.53v-33.32c0-3.22-5.18-13.92-5.35-20.35Zm3.38,52.34c0,1.69-.8,3.07-2.49,3.07h-13.45c-1.69,0-2.49-1.37-2.49-3.07v-31.88c0-2.06,2.25-6.48,4.45-14.96h9.35c1.75,7.05,4.62,12.24,4.62,14.96v31.88Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightblue02);
export default __webpack_public_path__ + "static/media/lightblue02.b1984aaa9c3f6877446f40c731039f9c.svg";
export { ForwardRef as ReactComponent };